﻿/*!
    *
    * Wijmo Library 5.20251.34
    * https://developer.mescius.com/wijmo
    *
    * Copyright(c) MESCIUS inc. All rights reserved.
    *
    * Licensed under the End-User License Agreement For MESCIUS Wijmo Software.
    * us.sales@mescius.com
    * https://developer.mescius.com/wijmo/licensing
    *
    */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { VueApi, WjComponentBehavior } from '@mescius/wijmo.vue2.base';
import * as wjcGridTransposedmultirow from '@mescius/wijmo.grid.transposedmultirow';
var WjTransposedMultiRowBehavior = /** @class */ (function (_super) {
    __extends(WjTransposedMultiRowBehavior, _super);
    function WjTransposedMultiRowBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjTransposedMultiRowBehavior.tag = 'wj-transposed-multi-row';
    WjTransposedMultiRowBehavior.props = [
        'isDisabled',
        'tabOrder',
        'newRowAtTop',
        'allowAddNew',
        'allowDelete',
        'allowDragging',
        'allowMerging',
        'allowResizing',
        'allowSorting',
        'allowPinning',
        'autoScroll',
        'autoRowHeights',
        'autoSizeMode',
        'autoGenerateColumns',
        'autoSearch',
        'caseSensitiveSearch',
        'quickAutoSize',
        'bigCheckboxes',
        'childItemsPath',
        'groupHeaderFormat',
        'headersVisibility',
        'showSelectedHeaders',
        'showMarquee',
        'showPlaceholders',
        'itemFormatter',
        'isReadOnly',
        'imeEnabled',
        'mergeManager',
        'selectionMode',
        'showGroups',
        'showSort',
        'showDropDown',
        'showAlternatingRows',
        'showErrors',
        'alternatingRowStep',
        'itemValidator',
        'validateEdits',
        'treeIndent',
        'itemsSource',
        'autoClipboard',
        'expandSelectionOnCopyPaste',
        'frozenRows',
        'frozenColumns',
        'cloneFrozenCells',
        'deferResizing',
        'sortRowIndex',
        'editColumnIndex',
        'stickyHeaders',
        'preserveSelectedState',
        'preserveOutlineState',
        'preserveWhiteSpace',
        'keyActionTab',
        'keyActionEnter',
        'rowHeaderPath',
        'virtualizationThreshold',
        'anchorCursor',
        'lazyRender',
        'refreshOnEdit',
        'copyHeaders',
        'columnGroups',
        'layoutDefinition',
        'commitEmptyEdits',
        'headersFocusability',
    ];
    WjTransposedMultiRowBehavior.events = [
        'initialized',
        'gotFocus',
        'lostFocus',
        'refreshing',
        'refreshed',
        'invalidInput',
        'beginningEdit',
        'cellEditEnded',
        'cellEditEnding',
        'prepareCellForEdit',
        'formatItem',
        'resizingColumn',
        'resizedColumn',
        'autoSizingColumn',
        'autoSizedColumn',
        'draggingColumn',
        'draggingColumnOver',
        'draggedColumn',
        'sortingColumn',
        'sortedColumn',
        'pinningColumn',
        'pinnedColumn',
        'resizingRow',
        'resizedRow',
        'autoSizingRow',
        'autoSizedRow',
        'draggingRow',
        'draggingRowOver',
        'draggedRow',
        'deletingRow',
        'deletedRow',
        'loadingRows',
        'loadedRows',
        'rowEditStarting',
        'rowEditStarted',
        'rowEditEnding',
        'rowEditEnded',
        'rowAdded',
        'groupCollapsedChanging',
        'groupCollapsedChanged',
        'columnGroupCollapsedChanging',
        'columnGroupCollapsedChanged',
        'itemsSourceChanging',
        'itemsSourceChanged',
        'selectionChanging',
        'selectionChanged',
        'scrollPositionChanged',
        'updatingView',
        'updatedView',
        'updatingLayout',
        'updatedLayout',
        'pasting',
        'pasted',
        'pastingCell',
        'pastedCell',
        'copying',
        'copied'
    ];
    WjTransposedMultiRowBehavior.classCtor = function () { return wjcGridTransposedmultirow.TransposedMultiRow; };
    return WjTransposedMultiRowBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.grid.transposedmultirow.TransposedMultiRow} control.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.grid.transposedmultirow.TransposedMultiRow} control it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjTransposedMultiRow = WjTransposedMultiRowBehavior.register();
function registerV3WjTransposedMultiRow(app) {
    app.component(WjTransposedMultiRowBehavior.tag, WjTransposedMultiRow);
}
export function registerGridTransposedMultirow(app) {
    if (VueApi.isV3Plus) {
        registerV3WjTransposedMultiRow(app);
    }
}
